import { faBan, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import type { IPagedListRowIndicator } from "../../components/UI/Declarations";

function isPagedListRowMarkedDeleted(item: unknown): boolean {
    const row = item as {
        isDeleted?: boolean;
        locationIsDeleted?: boolean;
        customerIsDeleted?: boolean;
    };
    return (
        row.isDeleted === true ||
        row.locationIsDeleted === true ||
        row.customerIsDeleted === true
    );
}

export const PAGED_LIST_DELETED_ROW_INDICATOR: IPagedListRowIndicator = {
    when: isPagedListRowMarkedDeleted,
    icon: faBan,
    className: "text-danger flex-shrink-0",
    title: "Deleted",
    ariaLabel: "Deleted",
};

export const PAGED_LIST_MAIN_LOCATION_ROW_INDICATOR: IPagedListRowIndicator = {
    when: (item) => (item as { isMainLocation?: boolean })?.isMainLocation === true,
    icon: faStar,
    className: "text-warning flex-shrink-0",
    title: "Primary address",
    ariaLabel: "Primary address",
};

export function resolvePagedListRowIndicators(
    showDeletedRowIndicator?: boolean,
    rowIndicators?: IPagedListRowIndicator[]
): IPagedListRowIndicator[] {
    return [
        ...(showDeletedRowIndicator ? [PAGED_LIST_DELETED_ROW_INDICATOR] : []),
        ...(rowIndicators ?? []),
    ];
}

export function renderPagedListRowLeadingIcons(
    item: unknown,
    indicators: IPagedListRowIndicator[]
): React.ReactNode {
    const active = indicators.filter((indicator) => indicator.when(item));
    if (active.length === 0) {
        return undefined;
    }

    return (
        <>
            {active.map((indicator, index) => (
                <FontAwesomeIcon
                    key={`${indicator.ariaLabel ?? indicator.title ?? "indicator"}-${index}`}
                    icon={indicator.icon}
                    className={indicator.className}
                    title={indicator.title}
                    aria-label={indicator.ariaLabel ?? indicator.title}
                />
            ))}
        </>
    );
}

export function wrapCellContentWithLeadingIcons(
    content: React.ReactNode,
    leadingIcons?: React.ReactNode
): React.ReactNode {
    if (!leadingIcons) {
        return content;
    }

    return (
        <span className="d-inline-flex align-items-center gap-2">
            {leadingIcons}
            {content}
        </span>
    );
}

export function injectLeadingIconsIntoTd(
    cell: React.ReactElement,
    leadingIcons?: React.ReactNode
): React.ReactElement {
    if (!leadingIcons) {
        return cell;
    }

    return React.cloneElement(
        cell,
        cell.props,
        wrapCellContentWithLeadingIcons(cell.props.children, leadingIcons)
    );
}
